import './tabazienda.css'
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import FarmManagement from './FarmManagement';

const TabAzienda = () => {
    const { t } = useTranslation(['usersetting']);
  
  return (
      <Container fluid className='farm-container'>
            <Row>
                <Col>
                    <Row>
                        <Col className='farm-header'>{t('usersetting:tiles.farmmanagement')}</Col>
                    </Row>
                    <Row>
                        <Col className='farm-field'><FarmManagement/></Col>
                    </Row>
                </Col>
            </Row>
        </Container>
  );
};

export default TabAzienda;